<template>
  <div class="page">
    <van-nav-bar title="内容样本审核" left-arrow @click-left="$router.back()"/>
    <van-tabs v-model="status" @change="load">
      <van-tab title="待审核" name="PENDING"/>
      <van-tab title="已通过" name="APPROVED"/>
      <van-tab title="已驳回" name="REJECTED"/>
    </van-tabs>
    <section v-for="item in items" :key="field(item,'id')">
      <header><b>{{ typeText(field(item, 'sample_type')) }}</b><span>{{ field(item, 'status') }}</span></header>
      <p>内容 ID：{{ field(item, 'brand_content_id') }}</p>
      <pre>{{ evidence(item) }}</pre>
      <div v-if="status==='PENDING'" class="actions">
        <van-button plain type="danger" size="small" @click="review(item,'REJECTED')">驳回</van-button>
        <van-button type="primary" size="small" @click="review(item,'APPROVED')">通过</van-button>
      </div>
    </section>
    <van-empty v-if="!loading && !items.length" description="暂无样本"/>
  </div>
</template>
<script>
import api from '@/api/brand';

export default {
  data() {
    return {status: 'PENDING', items: [], loading: false}
  }, created() {
    this.load()
  }, methods: {
    field(row, key) {
      return row[key] !== undefined ? row[key] : row[key.toUpperCase()]
    }, typeText(value) {
      return value === 'EXCELLENT' ? '优秀内容样本' : '失败内容样本'
    }, evidence(item) {
      const value = this.field(item, 'evidence_json');
      if (!value) return '暂无证据';
      try {
        return JSON.stringify(typeof value === 'string' ? JSON.parse(value) : value, null, 2)
      } catch (e) {
        return String(value)
      }
    }, async load() {
      this.loading = true;
      try {
        this.items = await api.samples(this.status) || []
      } catch (e) {
        this.$toast.fail(e.message)
      } finally {
        this.loading = false
      }
    }, async review(item, status) {
      try {
        await api.reviewSample(this.field(item, 'id'), {status, note: status === 'APPROVED' ? '证据有效，纳入样本库' : '证据不足或分类不准确'});
        this.$toast.success(status === 'APPROVED' ? '已纳入样本库' : '已驳回');
        await this.load()
      } catch (e) {
        this.$toast.fail(e.message)
      }
    }
  }
};
</script>
<style lang="less" scoped>
@import "./brand-page.less";

section {
  margin: .22rem .28rem;
  padding: .26rem;
  background: #fff;
  border-radius: .08rem
}

header {
  display: flex;
  justify-content: space-between;
  align-items: center
}

header b {
  font-size: .31rem
}

header span {
  color: #8b8e9e;
  font-size: .23rem
}

p {
  color: #666b7c;
  font-size: .26rem
}

pre {
  max-height: 3.2rem;
  overflow: auto;
  padding: .18rem;
  background: #f7f8fa;
  white-space: pre-wrap;
  font: inherit;
  font-size: .24rem;
  line-height: 1.55
}

.actions {
  display: flex;
  justify-content: flex-end;
  gap: .16rem;
  margin-top: .2rem
}
</style>



// WEBPACK FOOTER //
// src/views/brand/SampleReview.vue